import { useMutation } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

/**
 * QA tooling (gated by the `notification_test_send` feature flag): trigger
 * one/every feed workflow with fixture data to the calling user, so notification
 * templates and the in-app renderer can be verified in an environment without
 * manufacturing real entity events. The server enforces the flag (FORBIDDEN when
 * off); the UI additionally hides the buttons behind the same flag.
 */
export const useSendTestNotifications = () => {
  const trpc = useTRPC();

  return useMutation(trpc.frontend.notifications.test.send.mutationOptions());
};
